import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MultiFormsComponent } from 'src/app/ui/multi-forms/multi-forms.component';
import { BudgetService } from './service/budget.service';
import { Budget } from './models/budget';
import { TranslateService } from '@ngx-translate/core';
import { ProjectManagementComponent } from './project-management/project-management.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BudgetFillerComponent } from './budget-filler/budget-filler.component';
import { BudgetSummaryModalComponent } from './budget-summary-modal/budget-summary-modal.component';
import { ModalInfoComponent } from 'src/app/ui/modal-info/modal-info.component';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncDropdown } from 'src/app/models/async-dropdown';
import { LovApiService } from 'src/app/services/lov-api.service';
import { SortObject } from 'src/app/models/sortObject';
@Component({
  selector: 'njo-order-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.scss'],
  providers: [BudgetService],
})
export class BudgetComponent implements OnInit {
  public data: Budget[] = [];
  public orderId;
  public form: any;
  public forms = new UntypedFormArray([]);
  public submitFailed = false;
  public openedId: string;
  public modalRef: any;
  public budgetFillModalRef: any;
  public budgetSummaryModalRef: any;
  public type: AsyncDropdown[] = [];
  public typeLoading: boolean = false;
  public department: AsyncDropdown[] = [];
  public departmentLoading: boolean = false;
  @Input() orderName: string = '';
  tags: Array<string> = [];
  tagsSuggestion: Array<string> = [];

  @ViewChild(MultiFormsComponent) multiForm: MultiFormsComponent;

  constructor(
    private router: Router,
    public budgetService: BudgetService,
    public translate: TranslateService,
    private modalService: NgbModal,
    private lovApiService: LovApiService
  ) { }

  async ngOnInit() {
    var urlFragments = this.router.url.split('/');
    this.orderId = this.router.url.split('/')[2];
    this.openedId = urlFragments[urlFragments.findIndex((el) => el === 'budget') + 1];

  }

  initNewForm = () => {
    return this.initForm(new Budget());
  };

  initForm = (data: Budget) => {
    var descRows = data.description ? Math.round(data.description.length / 165) + 1 : 1;
    descRows = descRows <= 3 ? 3 : descRows;
    this.initDropdowns(data);
    let formGroup = new UntypedFormGroup({
      identifier: new UntypedFormControl(data.identifier),
      name: new UntypedFormControl(data.name, [Validators.required]),
      jiraProjectLink: new UntypedFormControl(data.jiraProjectLink),
      code: new UntypedFormControl(data.code),
      description: new UntypedFormControl(data.description),
      descriptionRows: new UntypedFormControl({ value: descRows, disabled: true }),
      jobCode: new UntypedFormControl(data.jobCode),
      budgetProducts: new UntypedFormControl(data.budgetProducts),
      project: new UntypedFormControl(data.project),
      addAllAvailableProducts: new UntypedFormControl(false),
      tags: new UntypedFormControl(data?.tags),
      type: new UntypedFormControl(data?.type, [Validators.required]),
      department: new UntypedFormControl(data?.department),
      jiraProjectActions: new UntypedFormControl({ value: data?.jiraProjectActions, disabled: true }),
    });
    return formGroup;
  };

  initDropdowns(data: Budget) {
    this.type.push(data.type || new AsyncDropdown());
  }

  async addTitleToCollapsable(forms) {
    forms.controls.forEach((item) => {
      var descRows = item.value.description ? Math.round(item.value.description.length / 165) + 1 : 1;
      descRows = descRows <= 3 ? 3 : descRows;
      item.controls.descriptionRows.setValue(descRows);
      /* calc products */
      var product = this.translate.instant('order.budget.noProducts');
      if (item.value.budgetProducts && item.value.budgetProducts.length > 0) {
        let hours = 0;
        item.value.budgetProducts.forEach((element) => {
          hours += element.quantityOrder;
        });
        product = '[ ' + Number(hours).toFixed(2) + 'h | ' + Number(hours / 8).toFixed(2) + 'd ]';
      }
      /* calc products end */
      /* projects */
      var project = this.translate.instant('order.budget.noProject');
      if (item.value.project && item.value.project.name) {
        let projectLink =
          '<a href="/project/' +
          item.value.project.identifier +
          '" class="url-budget-icon"><img class="icon fill-black"  aria-label="link" src="assets/ico/link-blue.svg" /></a>';
        let jiraUrl = item.value.jiraProjectLink;
        if (!jiraUrl && item.controls.jiraProjectActions.value) {
          jiraUrl = item.controls.jiraProjectActions.value.projectUrl;
        }
        let jiraLink =
          '<a href="' +
          jiraUrl +
          '" class="url-budget-jira" target="_blank"><img class="icon fill-black" aria-label="link" src="assets/ico/jira-icon.svg" /></a>';
        project = '[ ' + item.value.project.name + projectLink + jiraLink + ' ]';
      }
      /* end projects */
      item.name = `${item.value.name} ${product} ${project}`;
    });
  }

  addNewSection() {
    this.multiForm.addNewSection();
  }

  updateData() {
    this.multiForm.calcTotalHours(true);
    this.addTitleToCollapsable(this.forms);
 }


  sortProducts(item) {
    return item.sort(function (a, b) {
      if (a.product.code < b.product.code) {
        return 1
      } else if (a.product.code > b.product.code) {
        return -1;
      } else {
        return 0;
      }
    });

  }

  newProject(res) {
    this.modalRef = this.modalService.open(ProjectManagementComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-project-modal',
    });
    this.modalRef.componentInstance.modalRef = this.modalRef;
    this.modalRef.componentInstance.budgetId = res.budgetId;
    this.modalRef.componentInstance.orderId = this.orderId;
    this.modalRef.componentInstance.orderName = this.orderName;
    this.modalRef.componentInstance.projectId = res.projectId;
    this.modalRef.componentInstance.budget = this.forms.value.find((el) => el.identifier === res.budgetId);
    this.modalRef.componentInstance.budgets = this.forms.value;

    this.modalRef.result.then(
      (res) => { },
      (budget) => {
        if (!Array.isArray(budget) && budget && budget.identifier) {
          let formToUpdate = this.forms.controls.find((el) => el.value.identifier === budget.identifier);
          formToUpdate.patchValue(budget);
          this.addTitleToCollapsable(this.forms);
        }
        // when migrating project we have two budgets to refresh
        else if (Array.isArray(budget)) {
          budget.forEach((b) => {
            let formToUpdate = this.forms.controls.find((el) => el.value.identifier === b.identifier);
            if (formToUpdate) {
              formToUpdate.patchValue(b);
            }
          });
          this.addTitleToCollapsable(this.forms);
        }

        if (budget && budget.delete) {
          this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== budget.budgetId);
          this.addTitleToCollapsable(this.forms);
          this.multiForm.resetIds();
        }
        if (budget && budget.migrate) {
          let formToUpdate = this.forms.controls.find((el) => el.value.identifier === budget.budget.identifier);
          formToUpdate.patchValue(budget.budget);
          this.addTitleToCollapsable(this.forms);
        }
        this.multiForm.calcTotalHours(true);
        this.forms.updateValueAndValidity();
      }
    );
  }

  clearProducts(budgetId) {
    let formToUpdate: any = this.forms.controls.find((el) => el.value.identifier === budgetId);
    formToUpdate.controls['budgetProducts'].setValue([]);
  }

  budgetFill(budgetId) {
    this.budgetFillModalRef = this.modalService.open(BudgetFillerComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-filler-modal',
    });
    this.budgetFillModalRef.componentInstance.modalRef = this.budgetFillModalRef;
    this.budgetFillModalRef.componentInstance.budgetId = budgetId;
    this.budgetFillModalRef.componentInstance.orderId = this.orderId;
    this.budgetFillModalRef.result.then(
      (res) => { },
      (budget) => {
        if (budget && budget.identifier) {
          let formToUpdate = this.forms.controls.find((el) => el.value.identifier === budget.identifier);
          formToUpdate.patchValue(budget);
          this.addTitleToCollapsable(this.forms);
        }
        this.updateData();
      }
    );
  }

  budgetSummaryOpen() {
    this.budgetSummaryModalRef = this.modalService.open(BudgetSummaryModalComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-filler-modal',
    });
    this.budgetSummaryModalRef.componentInstance.modalRef = this.budgetSummaryModalRef;
    this.budgetSummaryModalRef.componentInstance.orderId = this.orderId;
    var budgets = this.forms.value.map((budget) => ({
      projectKey: budget.project?.jiraKey,
      budgetCode: budget.identifier,
    }));
    this.budgetSummaryModalRef.componentInstance.budgets = budgets;
  }

  getTags = (text: string): Observable<any> => {
    if (text.length > 0) {
      return this.budgetService.getTags(text.toLowerCase()).pipe(
        map((tagsSuggestion: any) =>
          tagsSuggestion.map((item: any) => {
            return item.value + ' (' + item.count + ')';
          })
        )
      );
    }
  };

  public transform(value): Observable<object> {
    var item;
    if (value && value.display) {
      var formattedValue = value.display;
      var formattedValue = value.display.split(' (')[0];
      item = { display: `${formattedValue}`, value: `${formattedValue}` };
    } else {
      item = { display: value, value: value };
    }
    return of(item);
  }

  async fetchType() {
    this.type = [];
    this.typeLoading = true;
    var sort: SortObject[] = [{ prop: 'name', dir: 'asc' }];
    this.type = await this.lovApiService.getDropdownValues('budget', 'type', sort);
    this.typeLoading = false;
  }

  async fetchDepartment() {
    this.department = [];
    this.departmentLoading = true;
    var sort: SortObject[] = [{ prop: 'name', dir: 'asc' }];
    this.department = await this.lovApiService.getDropdownValues('budget', 'department', sort);
    this.departmentLoading = false;
  }
}
